/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagGroupWithRelations } from '../../models/tag-group-with-relations';

export interface GetInventoryTags$Params {
  id: string;
  includeTags?: boolean;
  nested?: boolean;
}

export function getInventoryTags(http: HttpClient, rootUrl: string, params: GetInventoryTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagGroupWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, getInventoryTags.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('includeTags', params.includeTags, {});
    rb.query('nested', params.nested, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TagGroupWithRelations>>;
    })
  );
}

getInventoryTags.PATH = '/admin/inventories/{id}/tags';
